export default function pick(obj,list){var nextObj={};for(var key in obj)obj.hasOwnProperty(key)&&!0===list[key]&&(nextObj[key]=obj[key]);return nextObj}